import {
  FormContextProvider,
  SchemaFieldsWithContextUI,
} from '@sw-sw/lib-form';
import React, { MouseEventHandler, useMemo } from 'react';
import { FormModal, SubmitHandlerFn } from '../../Shared/form';
import { InspectionTemplateType } from '../../../utils/api/inspectionTemplateTypes';
import { UIControlType } from '@sw-sw/lib-form-control-types';

/**
 * @deprecated see @sw-sw/lib-inspection-templates
 */
interface InspectionTemplate {
  name: string;
  divisionId?: number | null;
  inspection_type_id?: number | null;
}

export interface IInspectionTemplateFormProps {
  handleSubmit: SubmitHandlerFn;
  handleClose: MouseEventHandler;
  title?: string;
  inspectionTemplate?: Partial<InspectionTemplate>;
  errorMsg?: boolean;
  inspectionTypes?: InspectionTemplateType[];
}

export const getSchema = (inspectionTypes: InspectionTemplateType[] = [], hideInspectionType: boolean = false) => {
  const fields: any = {
    name: {
      label: 'Name',
      validation: {
        required: true,
      },
    },
  };

  // Only add inspection_type_id field if not hidden
  if (!hideInspectionType) {
    fields.inspection_type_id = {
      label: 'Inspection Type',
      controlType: UIControlType.select,
      options: inspectionTypes.map(type => ({
        value: type.id,
        label: type.name,
      })),
      validation: {
        required: true,
      },

      placeholder: 'Select an inspection type',
    }
  };

  return fields;
};

const InspectionTemplateDetailsForm: React.FC<IInspectionTemplateFormProps> = ({
  handleSubmit,
  handleClose,
  title = 'Add/Modify an Inspection Template',
  inspectionTemplate = { name: '', tenants: [], divsionId: 0 },
  errorMsg,
  inspectionTypes = [],
}) => {
  // Hide inspection type field if title contains "finding" (case-insensitive)
  const hideInspectionType = title.toLowerCase().includes('finding');
  const schema = getSchema(inspectionTypes, hideInspectionType);

  // Prepare initial form data with default inspection type if needed
  const preparedInitialData = useMemo(() => {
    const data: any = { ...inspectionTemplate };

    // Check if current inspection_type_id exists in available types
    const currentTypeExists = inspectionTypes.some(
      type => type.id === data.inspection_type_id
    );

    // If no type or type doesn't exist, set first available
    if ((!data.inspection_type_id || !currentTypeExists) && inspectionTypes.length > 0) {
      data.inspection_type_id = inspectionTypes[0].id;
    }

    return data;
  }, [inspectionTemplate, inspectionTypes]);

  return (
    <FormContextProvider>
      <FormModal
        onCancel={handleClose}
        onSubmit={handleSubmit}
        modalProps={{
          title: title,
        }}
      >
        <SchemaFieldsWithContextUI
          schema={schema}
          initialFormData={preparedInitialData}
        />
        {errorMsg ? (
          <h5 className='error-messages finding-error'>
            This finding type name already exist. Please try another.
          </h5>
        ) : (
          ''
        )}
      </FormModal>
    </FormContextProvider>
  );
};

export default InspectionTemplateDetailsForm;
